import { render, staticRenderFns } from "./EmptyTemplate.vue?vue&type=template&id=2c1222a3&scoped=true"
import script from "./EmptyTemplate.vue?vue&type=script&lang=js"
export * from "./EmptyTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1222a3",
  null
  
)

export default component.exports